import ImageSwiperComponent from '../../views/image-swiper/base/swiper' 
import PostSwiperComponent from '../../views/post-swiper/base/swiper' 
import HeaderComponent from '../../views/header/header' 
import HeroComponent from '../../views/hero/hero'  
import CountUpComponent from '../../views/count-up/count-up' 
import BannerComponent from '../../views/banner/banner' 
import CTAComponent from '../../views/global_ctas/global_ctas' 
import ContentComponent from './global/content'

const components = {
  ImageSwiperComponent, 
  PostSwiperComponent, 
  HeaderComponent,   
  HeroComponent, 
  CountUpComponent, 
  BannerComponent, 
  CTAComponent, 
  ContentComponent
}

export default components;